import { z } from 'zod';
import { ZSchema } from '../utils/zodSchema';
import { mongoId } from '../utils/basicSchemas/_id.z.schema';
import { requiredString } from '../utils/basicSchemas/document.z.schema';
import { validateAgainstSchema, convertToTitleCase } from '../utils/util.validation.z';


export const MAX_POST_TITLE_LENGTH = 60;
export const MAX_POST_DESC_LENGTH = 500;

const postMediaObjectSchema = z.object(
    {
        images: z.array(z.string()),
        blurhash: z.array(z.string()),
        thumbnails: z.array(z.any()),
        type: z.array(z.string().optional()),
        workflow: z.array(z.any()),
    },
);

const pt = "post.title";
const pd = "post.description";
const ptf = convertToTitleCase(pt);
const pdf = convertToTitleCase(pd);

// Could use required string , but has regex so this will do 
const postTitleSchema = z.string()
    .min(1, `${pt} | ${ptf} must be at least one character`)
    .max(MAX_POST_TITLE_LENGTH,
        `${pt} | ${ptf} must be at most ${MAX_POST_TITLE_LENGTH} characters`)
const postDescriptionSchema = z.string()
    .min(1, `${pd} | ${pdf} must be at least one character`)
    .max(MAX_POST_DESC_LENGTH,
        `${pd} | ${pdf} must be at most ${MAX_POST_DESC_LENGTH} characters`)

const postPublishableSchema = z.object({
    type: z.enum(["Individual item", "Collection"]),
    title: postTitleSchema,
    description: postDescriptionSchema,
    category: requiredString("post.category", 1),
    subcategories: z.array(z.string()).nonempty({
        message: "post.subcategories | You must have at least one subcategory selected. "
    }),
    media: z.array(postMediaObjectSchema).nonempty().nullable().optional(),
    collaborators: z.array(z.any()).nullable().optional(),
    tags: z.array(z.any()).nullable().optional(),
    challenge: z.any().optional(),
});


const postIdSchema = z.object({
    id: mongoId("post id"),
});

// Take dirty , validate , return good data , return errors if bad 
const postPublishableValidator = (body: any) => {
    let bodyValidationReturn = validateAgainstSchema(postPublishableSchema, body);
    if (bodyValidationReturn.errors) {
        return { errors: bodyValidationReturn.errors };
    }
};

const postIdValidate = new ZSchema({ paramSchema: postIdSchema });

export { postIdValidate, postPublishableValidator };
